export var Constant = {
	DYNAMIC_PROPERTIES_MAP: {
		QR_WEBAR: "qRWEBAR",
	},
};

export const UI_FRAMEWORK = Object.freeze({
	VUE_UI: "vue_ui",
});
